import { Box } from "@chakra-ui/layout"
import { StyleProps } from "@chakra-ui/system"
import React from "react"

/** chakra uiのBoxに`display="inline"`を固定したもの */
export const Inline: React.FC<StyleProps> = ({ children, ...props }) => {
  return (
    <Box {...props} display="inline">
      {children}
    </Box>
  )
}
